export default __webpack_public_path__ + "static/artistBox-rem-kanashibari-50d81e77fa460c74e10ceb98bdfe8446.png";